import { render, staticRenderFns } from "./MainBoardView.vue?vue&type=template&id=0cf73c83&"
import script from "./MainBoardView.vue?vue&type=script&lang=js&"
export * from "./MainBoardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports